import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=10ec6a7a&scoped=true"
var script = {}
import style0 from "./Service.vue?vue&type=style&index=0&id=10ec6a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ec6a7a",
  null
  
)

export default component.exports